export const dashboardZh = {
  header: {
    title: '数据概览',
    subtitle: '实时监控短信发送数据与账户状态',
  },
  filter: {
    refresh: '刷新',
    msgType: '短信类型',
  },
  statCards: {
    submitNum: '提交成功数',
    sendSucc: '发送成功数',
    successRate: '发送成功率',
    cost: '消耗金额',
  },
  charts: {
    costTitle: '消耗金额统计',
    costSubtitle: 'TOP 5 · 按国家消耗分布',
    sendingTitle: '国家发送统计',
    sendingSubtitle: 'TOP 5 · 按提交数量排序',
    viewMore: '查看更多',
    totalCost: '总消耗',
    sendCountLabel: '发送数量',
    legendCountry: '国家',
    legendPct: '占比',
    legendCost: '消耗',
    legendVolume: '发送量',
    emptyCostTitle: '暂无消耗数据',
    emptyCostDesc: '当前时间段内没有消耗记录',
    emptySendingTitle: '暂无发送数据',
    emptySendingDesc: '当前时间段内没有发送记录',
  },
  recentTasks: {
    title: '近期发送任务',
    subtitle: '最近5条任务记录',
    viewAll: '查看全部',
    sendTime: '发送时间',
    successRate: '成功率',
    emptyTitle: '暂无任务记录',
    emptyDesc: '当前时间段内没有发送任务',
    todayPrefix: '今天',
  },
  recentSms: {
    title: '最近短信',
    subtitle: '近3分钟发送记录',
    emptyTitle: '暂无短信记录',
    emptyDesc: '近3分钟内没有发送短信',
  },
  status: {
    completed: '已完成',
    processing: '处理中',
    failed: '已失败',
    delivered: '已送达',
    sending: '发送中',
    unknown: '未知',
  },
  modal: {
    costTitle: '消耗金额统计 - 全部国家',
    costSubtitle: '按消耗金额从高到低排列',
    sendingTitle: '国家发送统计 - 全部国家',
    sendingSubtitle: '按发送数量从高到低排列',
    timeRange: '时间范围',
    countryCount: '{n} 个国家',
    headers: {
      rank: '排名',
      country: '国家',
      cost: '消耗金额',
      percentage: '占比',
      volume: '发送量',
      sendCount: '发送数量',
    },
  },
}

export const dashboardEn = {
  header: {
    title: 'Dashboard',
    subtitle: 'Monitor SMS delivery metrics and account status in real time',
  },
  filter: {
    refresh: 'Refresh',
    msgType: 'Message Type',
  },
  statCards: {
    submitNum: 'Submitted',
    sendSucc: 'Delivered',
    successRate: 'Delivery Rate',
    cost: 'Total Cost',
  },
  charts: {
    costTitle: 'Cost by Country',
    costSubtitle: 'TOP 5 · Cost distribution by country',
    sendingTitle: 'Volume by Country',
    sendingSubtitle: 'TOP 5 · Sorted by submission count',
    viewMore: 'View All',
    totalCost: 'Total Cost',
    sendCountLabel: 'Sent',
    legendCountry: 'Country',
    legendPct: 'Share',
    legendCost: 'Cost',
    legendVolume: 'Volume',
    emptyCostTitle: 'No cost data',
    emptyCostDesc: 'No cost records in the selected period',
    emptySendingTitle: 'No sending data',
    emptySendingDesc: 'No sending records in the selected period',
  },
  recentTasks: {
    title: 'Recent Tasks',
    subtitle: 'Latest 5 task records',
    viewAll: 'View All',
    sendTime: 'Sent At',
    successRate: 'Success Rate',
    emptyTitle: 'No task records',
    emptyDesc: 'No sending tasks in the selected period',
    todayPrefix: 'Today',
  },
  recentSms: {
    title: 'Recent Messages',
    subtitle: 'Sent in the last 3 minutes',
    emptyTitle: 'No message records',
    emptyDesc: 'No messages sent in the last 3 minutes',
  },
  status: {
    completed: 'Completed',
    processing: 'Processing',
    failed: 'Failed',
    delivered: 'Delivered',
    sending: 'Sending',
    unknown: 'Unknown',
  },
  modal: {
    costTitle: 'Cost by Country — All Countries',
    costSubtitle: 'Sorted by cost, highest first',
    sendingTitle: 'Volume by Country — All Countries',
    sendingSubtitle: 'Sorted by submission count, highest first',
    timeRange: 'Time Range',
    countryCount: '{n} countries',
    headers: {
      rank: 'Rank',
      country: 'Country',
      cost: 'Cost',
      percentage: 'Share',
      volume: 'Volume',
      sendCount: 'Sent',
    },
  },
}

export const dashboardJa = {
  header: {
    title: 'ダッシュボード',
    subtitle: 'SMS送信データとアカウント状態をリアルタイム監視',
  },
  filter: {
    refresh: '更新',
    msgType: 'SMSタイプ',
  },
  statCards: {
    submitNum: '送信成功数',
    sendSucc: '配信成功数',
    successRate: '配信成功率',
    cost: '消費金額',
  },
  charts: {
    costTitle: '消費金額統計',
    costSubtitle: 'TOP 5 · 国別消費分布',
    sendingTitle: '国別送信統計',
    sendingSubtitle: 'TOP 5 · 送信数順',
    viewMore: 'すべて表示',
    totalCost: '総消費',
    sendCountLabel: '送信数',
    legendCountry: '国',
    legendPct: '割合',
    legendCost: '消費',
    legendVolume: '送信量',
    emptyCostTitle: '消費データなし',
    emptyCostDesc: '選択期間に消費記録がありません',
    emptySendingTitle: '送信データなし',
    emptySendingDesc: '選択期間に送信記録がありません',
  },
  recentTasks: {
    title: '最近の送信タスク',
    subtitle: '直近5件のタスク記録',
    viewAll: 'すべて表示',
    sendTime: '送信時間',
    successRate: '成功率',
    emptyTitle: 'タスク記録なし',
    emptyDesc: '選択期間に送信タスクがありません',
    todayPrefix: '今日',
  },
  recentSms: {
    title: '最近のSMS',
    subtitle: '直近3分の送信記録',
    emptyTitle: 'SMS記録なし',
    emptyDesc: '直近3分間に送信されたSMSはありません',
  },
  status: {
    completed: '完了',
    processing: '処理中',
    failed: '失敗',
    delivered: '配信済み',
    sending: '送信中',
    unknown: '不明',
  },
  modal: {
    costTitle: '消費金額統計 - 全国',
    costSubtitle: '消費金額の高い順',
    sendingTitle: '国別送信統計 - 全国',
    sendingSubtitle: '送信数の多い順',
    timeRange: '期間',
    countryCount: '{n} カ国',
    headers: {
      rank: '順位',
      country: '国',
      cost: '消費金額',
      percentage: '割合',
      volume: '送信量',
      sendCount: '送信数',
    },
  },
}
